/**
 * Nested-IA alias route — round 4 / #228 (re-fixed round 5).
 *
 * Mounts the MCP-server list at `/connections/mcp` so the Codex
 * full-baseline IA inventory resolves. The same component is also
 * mounted at `/connections/` (the index route); both render the same
 * MCP list.
 *
 * Round 5 fix:
 *   The TanStack file-based router treats `mcp.marketplace.tsx` and
 *   `mcp.$connectionId.tsx` as child routes of THIS file (parentRoute:
 *   ConnectionsMcpRoute). When the round-4 component just rendered the
 *   list directly, those children had nowhere to mount, so navigating
 *   to /connections/mcp/<id> matched the parent + child but only the
 *   parent (the list) ever painted.
 *
 *   Fix: render the list when the path is exactly `/connections/mcp`,
 *   otherwise hand off to <Outlet /> so the child detail / marketplace
 *   route can take over. Mirrors the pattern in
 *   automate/playbooks.tsx (#169) — see comment there for why hook
 *   ordering matters.
 */

import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { McpServersPage } from './index';

function McpRouteComponent() {
  const location = useLocation();
  const isIndex =
    location.pathname === '/connections/mcp' ||
    location.pathname === '/connections/mcp/';
  if (!isIndex) return <Outlet />;
  return <McpServersPage />;
}

export const Route = createFileRoute('/connections/mcp')({
  component: McpRouteComponent,
});
